












import {Vue, Component, Prop} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'
import {DialogState} from '@/store'
import UpdateProfileImageDialog from './UpdateProfileImageDialog.vue'
import {Attachment} from '@/lib/kepler/interfaces'
import Utils from '@/utils'
import ConfirmDialogCallback from '@/views/ConfirmDialogCallback.vue'
import Sheet from '@/components/proxy/Sheet.vue'
import Layout from '@/components/proxy/Layout.vue'

declare let device: any

@Component({
  components: {
    Layout,
    Sheet,
    Img: Utils.loadComponent('proxy/Image'),
    ProgressCircular: Utils.loadComponent('proxy/ProgressCircular'),
    UploadTypeChooser: Utils.loadComponent('UploadTypeChooser'),
    Avatar: Utils.loadComponent('proxy/Avatar'),
    Badge: Utils.loadComponent('proxy/Badge'),
  },
  name: 'BadgeProfileImage',
})

export default class BadgeProfileImage extends Vue {
  @State((state) => state.configuration.appConfig.fields_configuration) public fieldConfigState!: any
  @Action('openDialog') private openDialog!: any

  @Prop() private uploadAction!: (token: any) => any
  @Prop({}) private imageUrl?: string
  @Prop({
    type: Number,
    default: () => 100,
  }) private size!: number

  private loading: boolean = false
  private open: boolean = false
  private uploadResponse: Attachment = {
    url: '',
    mime: '',
    token: '',
  }

  get revalidate() {
    const r: '0' | '1' | undefined = this.fieldConfigState.revalidate_driver_on_selfie_change
    return r === '1' || false
  }

  get profileImage() {
    return this.uploadResponse.url.length > 0 ? this.uploadResponse.url : this.imageUrl ? this.imageUrl : 'img/icons/profile.svg'
  }

  get isBrowser() {
    return device.platform === 'browser'
  }

  protected chooseUploader() {
    const openChooseUploader = () => {
      if (this.isBrowser) {
        this.uploadImageDialog()
        return
      }
      this.open = true
    }

    if (this.revalidate) {
      this.openDialog(new DialogState(ConfirmDialogCallback, {
        code: '',
        title: this.$t('profile.change_profile_image_revalidate.title'),
        subtitle: this.$t('profile.change_profile_image_revalidate.subtitle'),
        confirmText: '',
        confirmColor: 'warning',
        imageState: 'warn.svg',
        showCloseButton: false,
        confirmCallback: () => {
          openChooseUploader()
        },
        cancelCallback: () => false,
      }))
    } else {
      openChooseUploader()
    }
  }

  protected toggleChooser() {
    this.open = !this.open
  }

  protected uploadImageDialog() {
    this.openDialog(new DialogState(UpdateProfileImageDialog, {
      cancelCallback: () => {
        return null
      },
      uploadCallback: (response: Attachment) => {
        this.setImage(response)
      },
    }))
  }

  protected setImage(data: Attachment) {
    this.uploadResponse = data
    this.loading = true
    this.uploadAction(this.uploadResponse).then(() => {
      this.loading = false
    })
  }
}
